import {FC, isValidElement, ReactNode, useState} from "react";
import {DatePicker, Flex, Typography} from "antd";
import styles from './EditableStatistic.module.css';
import {Dayjs} from "dayjs";
import cx from "classnames";

type Props = {
    title: string;
    value: ReactNode;
    onChange?: (value: string) => void;
    forceContentStyles?: boolean;
    preLine?: boolean;
}

const EditableStatisticGeneric: FC<Props> = ({ title, value, onChange, forceContentStyles, preLine }) => (
    <Flex vertical gap={4}>
        <Typography.Text type="secondary" className={styles.title}>{title}</Typography.Text>
        {isValidElement(value) && !forceContentStyles ? value : preLine ? (
            <Typography.Paragraph className={cx(styles.content, styles.preLine)} editable={onChange ? { onChange } : undefined}>{value}</Typography.Paragraph>
        ) : (
            <Typography.Text className={styles.content} editable={onChange ? { onChange } : undefined}>{value}</Typography.Text>
        )}
    </Flex>
);

type DateProps = {
    title: string;
    value: Dayjs;
    onChange?: (value: Dayjs) => void;
}

const EditableStatisticDate: FC<DateProps> = ({ title, value, onChange }) => {
    const [editing, setEditing] = useState(false);

    return (
        <Flex vertical gap={4}>
            <Typography.Text type="secondary" className={styles.title}>{title}</Typography.Text>
            <Typography.Text
                className={styles.content}
                editable={onChange ? { editing: false, onStart: () => setEditing(true) } : undefined}
            >
                {editing ? (
                    <DatePicker
                        format={{
                            format: 'DD.MM.YYYY',
                            type: 'mask'
                        }}
                        defaultValue={value}
                        onChange={(v) => {
                            onChange?.(v);
                            setEditing(false)
                        }}
                    />
                ) : value.format('DD.MM.YYYY')}
            </Typography.Text>
        </Flex>
    )
}

export const EditableStatistic = Object.assign(EditableStatisticGeneric, {
    Date: EditableStatisticDate
});